export const names: { [key: string]: string } = {
  lenyur: "Мам",
  vanyur: "Пап",
  ilyur: "Иль",
  kaltan: "Мам",
  ksutyn: "Ксюш",
  letyn: "Леш",
  nasaf: "Наст",
  saftan: "Тан",
};

export const photoCounts: { [key: string]: number } = {
  lenyur: 6,
  vanyur: 6,
  ilyur: 4,
  kaltan: 6,
  ksutyn: 5,
  letyn: 6,
  nasaf: 5,
  saftan: 5,
};

export const thanks: { [key: string]: string[] } = {
  lenyur: [
    `Большое спасибо за теплые слова и помощь в подготовке нашего праздника! 
    Костюм жениха был подобран идеально.`,

    `Мы очень рады, что в этом путешествии рядом с нами были самые близкие люди. 
     Было здорово вместе гулять по живописным местам, пробовать новые блюда и открывать новые виды.`,

    `С нетерпением ждём новых семейных приключений!`,
  ],
  vanyur: [
    `Мы очень благодарны за прекрасный совместный отпуск! 
    Было здорово покорять вместе горные вершины, 
    гулять у водопадов и чеканить монеты! `,

    `Большое спасибо за помощь в подготовке к свадьбе. 
     С нетерпением ждём новых встреч и совместных праздников!`,
  ],
  ilyur: [
    `Благодарим за всю помощь в организации нашего праздника! 
    Без тебя он бы точно не получился таким чудесным.`,

    `Спасибо, что помог нам реализовать задумку с монетами 
    и подготовил идеальный банкет. Мы очень рады, 
    что разделили этот особенный день с близкими людьми.`,

    `Надеемся, что впереди нас ждёт ещё больше совместных праздников!`,
  ],
  kaltan: [
    `Большое спасибо за всю помощь в подготовке нашего праздника. 
    Свадебное платье выглядело чудесно — благодаря твоей заботе о каждой детали.`,

    `Мы очень ценим, что ты была рядом в этот важный момент. 
    Надеемся, что горный воздух и красивые виды принесли не только радость, 
    но и пользу для здоровья.`,

    `Уверены, что впереди у нас будет ещё много таких замечательных совместных 
    встреч и праздников!`,
  ],
  ksutyn: [
    `Мы очень рады, что вы смогли приехать все вместе, 
    без вас этот день не был бы таким весёлым и душевным.`,

    `Знаем, что путешествия с детьми не всегда получаются отдыхом для родителей, 
    но надеемся, что эта поездка была интересной. Очень рады, что вы нашли время подняться на самую вершину!`,

    `С нетерпением ждём новых семейных праздников!`,
  ],
  letyn: [
    `Благодарим за участие в нашем празднике! 
    Теперь мы точно знаем, кто в нашей большой семье настоящий мастер в чеканке монет.`,

    `Мы очень рады, что вы смогли присоединиться к нашему путешествию все вчетвером. 
    Девочки были важной частью церемонии и справились замечательно!`,

    `Надеемся, что впереди нас ждёт ещё много тёплых семейных встреч!`,
  ],
  nasaf: [
    `Большое спасибо за чудесные пожелания и проведение весёлой игры на празднике!`,

    `Надеемся, что прогулка к вершинам и водопадам оставила только приятные воспоминания. 
    Горные пейзажи, свежий воздух и немножко физической нагрузки — то, что нужно для отличного отпуска.`,

    `Благодарим за твою доброту и искренность!`,
  ],
  saftan: [
    `Дорогая фея-крёстная, было здорово провести это путешествие вместе! 
    Надеемся, что воспоминания о празднике согреют даже в самом северном городе страны.`,

    `Спасибо тебе за добрые слова, поддержку и ту невероятную энергию, что ты привносишь! 
    Мы счастливы, что ты была рядом в этот важный день.`,
  ],
};
